const DEFAULT_GRAYSCALE_BOUNDARY = 130; // 默认背景和内容灰度分界值
/**
 * 设置图像数据指定位置为透明色0
 *
 * @param imgDataArr
 * @param pos
 */
function setTransparent(imgDataArr, pos) {
    imgDataArr[pos] = 0;
    imgDataArr[pos + 1] = 0;
    imgDataArr[pos + 2] = 0;
    imgDataArr[pos + 3] = 0;
}

// 去除浅色背景
/**
 *
 * @param pos
 * @param resultImgDataArr
 */
function rmWhiteBg(pos, resultImgDataArr) {
    let rValue = resultImgDataArr[pos], gValue = resultImgDataArr[pos + 1], bValue = resultImgDataArr[pos + 2];
    let garyScale = rValue * 0.299 + gValue * 0.578 + bValue * 0.114; //图片灰度，0黑255白色
    // console.log('garyScale: ', garyScale);
    if (garyScale >= DEFAULT_GRAYSCALE_BOUNDARY) {
        setTransparent(resultImgDataArr, pos);
        // 浅色，默认背景
    } else {
        // 深色，默认文字
    }
}

if (window.CanvasPixelArray) {
    window.CanvasPixelArray.prototype.set = function (arr) {
        const l = this.length;

        for (let i = 0; i < l; i++) {
            this[i] = arr[i];
        }
    };
}

// 自动化透明图片
/**
 *
 * @param imgDataArr
 * @param resultImgDataArr
 * @param imgHandlerCtx
 * @param img
 */
function autoTransparetCanvasImg(imgDataArr, resultImgDataArr, imgHandlerCtx, img) {
    if (imgDataArr.length === 0) {
        return;
    }

    if (resultImgDataArr.length === 0) {
        resultImgDataArr = imgDataArr.slice(0); // 克隆原数组
    }

    for (let pos = img.width * img.height * 4 - 4; pos >= 0; pos = pos - 4) {
        rmWhiteBg(pos, resultImgDataArr);
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const imgData = ctx.createImageData(img.width, img.height);
    imgData.data.set(resultImgDataArr);

    imgHandlerCtx.putImageData(imgData, 0, 0);
}

// 设置中间元素 canvas 大小
/**
 *
 * @param imgHandler
 * @param img
 */
function setCanvasSize(imgHandler, img) {
    imgHandler.width = img.width;
    imgHandler.height = img.height;
}

export default {
    data() { return {}; },
    methods: {
        // 使用中间元素 canvas 透明化图像
        transparentImg(b64) {
            let imgHandler = document.createElement('canvas'), img = new Image();
            let imgHandlerCtx = imgHandler.getContext('2d');
            img.src = b64;
            let imgDataArr = [], resultImgDataArr = [];
            return new Promise((resolve, reject) => {
                img.onload = () => {
                    setCanvasSize(imgHandler, img);
                    imgHandlerCtx.drawImage(img, 0, 0);
                    imgDataArr = imgHandlerCtx.getImageData(0, 0, img.width, img.height).data;
                    resultImgDataArr = imgDataArr.slice(0); // 克隆原数组
                    autoTransparetCanvasImg(imgDataArr, resultImgDataArr, imgHandlerCtx, img);
                    resolve(imgHandler.toDataURL());
                };
            });

        },
    },
};
